import { redirectToOrigin } from '~/utils/helper';

export const baseFetchFactory = (
  processRequestInfo?: (info: RequestInfo) => RequestInfo,
  processRequestInit?: (init?: RequestInit) => RequestInit,
  processResponse?: (response: Response) => Promise<Response>,
) => {
  return (info: RequestInfo, init?: RequestInit): Promise<Response> => {
    const processedInfo = processRequestInfo?.(info) || info;
    const processedInit = processRequestInit?.(init) || init;

    return window.fetch(processedInfo, processedInit).then((response) => {
      // TODO: This redirect is rather aggressive,
      //  and can be confusing to user when it happens unexpectedly.
      //  Should probably show error page before redirecting to root.
      //  Would also help with debugging as you could possibly check the error
      //  before browser logs are reset.

      const errorAllowedOnUrl = (url: string, allowedPaths: string[]) => {
        const urlPath = url.replace(window.location.origin, '');
        return allowedPaths.some((path) => urlPath.startsWith(path));
      };

      const allowErrorsFromUrlPaths = ['/d/json/org/unit/'];

      if (
        [401, 403].includes(response.status) &&
        !errorAllowedOnUrl(response.url, allowErrorsFromUrlPaths)
      ) {
        // TODO: Add logging of these errors to Kibana or something?
        redirectToOrigin(`${response.status} error`);
      }

      return processResponse?.(response) || response;
    });
  };
};
